"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utcToZonedTime_1 = __importDefault(require("date-fns-tz/utcToZonedTime"));
const KSA_TIMEZONE_1 = __importDefault(require("../../../constants/date/KSA_TIMEZONE"));
/**
 * Returns local KSA timezone timestamp from GMT time
 * @param {number} gmtTimeStamp in epoch format
 * @returns {Date}
 */
function getLocalTimeStampFromGMT(gmtTimeStamp) {
    const d = new Date(gmtTimeStamp * 1000); // conver to ms
    return (0, utcToZonedTime_1.default)(d, KSA_TIMEZONE_1.default); // returns KSA Date object
}
exports.default = getLocalTimeStampFromGMT;
